import { SharingCallout } from '../../sharingCallout/SharingCallout';
import {
  ItemCopyLinkAction as BaseItemCopyLinkAction,
  IItemCopyLinkActionProps as IBaseItemCopyLinkActionProps,
  ItemShareAction as BaseItemShareAction,
  IItemShareActionProps as IBaseItemShareActionProps,
  CopyLinkAction as BaseCopyLinkAction,
  ICopyLinkActionProps as IBaseCopyLinkActionProps,
  ShareAction as BaseShareAction,
  IShareActionProps as IBaseShareActionProps
} from '../../base/actions/share/ShareAction';
import { IDecoratedProps } from '../../../utilities/components/Decorators';
import { connectToItemCache } from '../../decorators/connectToItemCache';

function injectSharingCallout(): Pick<IBaseItemCopyLinkActionProps, 'sharingWizard'> {
  return {
    sharingWizard: SharingCallout
  };
}

export type IItemCopyLinkActionProps =
  IDecoratedProps<IBaseItemCopyLinkActionProps, Pick<IBaseItemCopyLinkActionProps, 'sharingWizard'>, {}>;

export const ItemCopyLinkAction: React.ComponentType<IItemCopyLinkActionProps> =
  connectToItemCache(injectSharingCallout)(BaseItemCopyLinkAction);

export type IItemShareActionProps = IDecoratedProps<IBaseItemShareActionProps, Pick<IBaseItemShareActionProps, 'sharingWizard'>, {}>;

export const ItemShareAction: React.ComponentType<IItemShareActionProps> =
  connectToItemCache(injectSharingCallout)(BaseItemShareAction);

export type ICopyLinkActionProps = IDecoratedProps<IBaseCopyLinkActionProps, Pick<IBaseCopyLinkActionProps, 'sharingWizard'>, {}>;

export const CopyLinkAction: React.ComponentType<ICopyLinkActionProps>
  = connectToItemCache(injectSharingCallout)(BaseCopyLinkAction);

export type IShareActionProps = IDecoratedProps<IBaseShareActionProps, Pick<IBaseShareActionProps, 'sharingWizard'>, {}>;

export const ShareAction: React.ComponentType<IShareActionProps>
  = connectToItemCache(injectSharingCallout)(BaseShareAction);
